var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      !_vm.isActivePopover
        ? _c(
            "v-tooltip",
            {
              attrs: {
                color: "grey-background",
                right: "",
                transition: "scale-transition",
                "max-width": 300,
                "open-on-hover":
                  _vm.isTooltip &&
                  !!_vm.activeStatus.detail &&
                  _vm.activeStatus.detail !== _vm.activeStatus.summary,
              },
              scopedSlots: _vm._u(
                [
                  {
                    key: "activator",
                    fn: function ({ on }) {
                      return [
                        _vm.activeStatus
                          ? _c(
                              "v-chip",
                              _vm._g(
                                {
                                  class: [
                                    {
                                      "px-2": _vm.activeShortMode.includes(
                                        _vm.$route.name
                                      ),
                                    },
                                    {
                                      "chip-status-no-truncate": _vm.noTruncate,
                                    },
                                  ],
                                  attrs: {
                                    color: _vm.activeStatus.color,
                                    small: "",
                                    label: "",
                                  },
                                },
                                _vm.isTooltip &&
                                  _vm.activeStatus.detail &&
                                  _vm.activeStatus.detail !==
                                    _vm.activeStatus.summary
                                  ? on
                                  : false
                              ),
                              [
                                _vm.routeList.includes(_vm.$route.name) ||
                                _vm.showDetail ||
                                _vm.customText
                                  ? _c(
                                      "span",
                                      {
                                        staticClass: "font-weight-semibold",
                                        class: _vm.noTruncate
                                          ? "chip-status-text-wrap"
                                          : "d-inline-block text-truncate",
                                        style: _vm.noTruncate
                                          ? ""
                                          : "max-width: 150px;",
                                      },
                                      [
                                        _vm.customText
                                          ? [
                                              _c("span", [
                                                _vm._v(_vm._s(_vm.customText)),
                                              ]),
                                            ]
                                          : [
                                              "DocumentsList",
                                              "SummariesList",
                                              "SummariesRetrieve",
                                              "PurchaseList",
                                              "PendingReceiveRetrieve",
                                              "PendingReceiveList",
                                              "DocumentsRetrieve",
                                              "DocumentsBatchRetrieve",
                                              "PurchaseRetrieve",
                                            ].includes(_vm.$route.name)
                                          ? [
                                              _c("span", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$route.name ===
                                                      "DocumentsRetrieve"
                                                      ? _vm.activeStatus.detail
                                                      : `${
                                                          _vm.activeStatus
                                                            .summary
                                                        } ${
                                                          _vm.activeStatus
                                                            .id === "OBS"
                                                            ? "con reparo"
                                                            : ""
                                                        }`
                                                  )
                                                ),
                                              ]),
                                            ]
                                          : _vm._e(),
                                      ],
                                      2
                                    )
                                  : _vm._e(),
                                _c(
                                  "v-icon",
                                  {
                                    attrs: {
                                      right: !_vm.activeShortMode.includes(
                                        _vm.$route.name
                                      ),
                                    },
                                  },
                                  [_vm._v(_vm._s(_vm.activeStatus.icon))]
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                      ]
                    },
                  },
                ],
                null,
                false,
                1222026873
              ),
            },
            [
              _c("div", [
                _vm.detail
                  ? _c("span", {
                      staticClass: "d-block px-3 py-2",
                      domProps: { innerHTML: _vm._s(_vm.detail) },
                    })
                  : (_vm.activeStatus || {}).detail === "Enviado a SII"
                  ? _c("span", { staticClass: "d-block px-3 py-2" }, [
                      _vm._v(_vm._s(_vm.$t("generals.Enviado a SII"))),
                    ])
                  : ![
                      "PurchaseList",
                      "PendingReceiveList",
                      "PendingReceiveRetrieve",
                      "PurchaseRetrieve",
                    ].includes(_vm.$route.name)
                  ? _c("span", { staticClass: "d-block px-3 py-2" }, [
                      _vm._v(_vm._s(_vm.activeStatus.detail)),
                    ])
                  : _vm._e(),
              ]),
            ]
          )
        : _vm.activeStatus?.id
        ? _c(
            "v-menu",
            {
              staticClass: "list-active-draw",
              attrs: {
                right: "",
                "close-delay": 100,
                "open-on-click": false,
                "open-on-hover": !!_vm.detail,
                "open-delay": 10,
                "nudge-right": 20,
                "offset-x": "",
                "max-width": "300",
              },
              scopedSlots: _vm._u([
                {
                  key: "activator",
                  fn: function ({ on, attrs }) {
                    return [
                      _c(
                        "v-chip",
                        _vm._g(
                          _vm._b(
                            {
                              class: {
                                "px-2": _vm.activeShortMode.includes(
                                  _vm.$route.name
                                ),
                              },
                              attrs: {
                                color: _vm.activeStatus.color,
                                small: "",
                                label: "",
                              },
                            },
                            "v-chip",
                            attrs,
                            false
                          ),
                          _vm.detail !== _vm.activeStatus.summary ? on : false
                        ),
                        [
                          _vm.routeList.includes(_vm.$route.name) ||
                          _vm.showDetail
                            ? _c(
                                "span",
                                {
                                  staticClass: "d-inline-block text-truncate",
                                  staticStyle: { "max-width": "150px" },
                                },
                                [
                                  [
                                    "DocumentsList",
                                    "SummariesList",
                                    "SummariesRetrieve",
                                    "PurchaseList",
                                    "DocumentsRetrieve",
                                    "DocumentsBatchRetrieve",
                                    "PurchaseRetrieve",
                                  ].includes(_vm.$route.name)
                                    ? [
                                        _c(
                                          "span",
                                          {
                                            staticClass: "font-weight-semibold",
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$route.name ===
                                                  "DocumentsRetrieve"
                                                  ? _vm.activeStatus.detail
                                                  : `${
                                                      _vm.activeStatus.summary
                                                    } ${
                                                      _vm.activeStatus.id ===
                                                      "OBS"
                                                        ? "con reparo"
                                                        : ""
                                                    }`
                                              )
                                            ),
                                          ]
                                        ),
                                      ]
                                    : _vm._e(),
                                ],
                                2
                              )
                            : _vm._e(),
                          _c(
                            "v-icon",
                            {
                              attrs: {
                                right: !_vm.activeShortMode.includes(
                                  _vm.$route.name
                                ),
                              },
                            },
                            [_vm._v(_vm._s(_vm.activeStatus.icon))]
                          ),
                        ],
                        1
                      ),
                    ]
                  },
                },
              ]),
            },
            [
              _c("v-list", { staticClass: "pa-0" }, [
                _vm.detail
                  ? _c("span", {
                      staticClass: "d-block caption px-3",
                      staticStyle: { "line-height": "1.2" },
                      domProps: {
                        innerHTML: _vm._s(
                          _vm.detail || _vm.activeStatus.detail
                        ),
                      },
                    })
                  : _vm._e(),
              ]),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }